import { Pipe, PipeTransform } from "@angular/core";
import { ProductModel } from "../models/product.model";

@Pipe({
  name: "category",
})
export class CategoryPipe implements PipeTransform {
  transform(items: any[], catName: string): any {
    return items.filter((item) => item.productCategory === catName);
  }
}
